module.exports = __webpack_public_path__ + "img/img01.712a9914.png";